import "core-js/modules/es.promise.js";
import { ENV_ANDROID, ENV_IOS } from '../../const';
import { appVersion, env } from '../../getNativeInfo';
import { copyTextToClipboard, notInApp, prepareApi } from '../../utils';
prepareApi(['bcz_system']);
/**
 * 拷贝文本内容至剪切板
 *
 * *返回值为 1 需要自行展示 toast*
 *
 * @param text 要拷贝到剪贴板的文本内容
 */

export function copyToClipboard(text) {
  return new Promise(function (resolve) {
    if (copyTextToClipboard(text)) {
      resolve(1);
    } else if (env === ENV_IOS) {
      window.webkit.messageHandlers.copy_to_clipboard.postMessage(text);
      resolve(1);
    } else if (env === ENV_ANDROID) {
      window.bcz_system.copyToClipboard(text); // 安卓旧版本（<= 7.1.1）APP 会展示 toast

      resolve(Number(appVersion) <= 7010100 ? 0 : 1);
    } else {
      throw notInApp({
        param: text,
        api: 'copyToClipboard'
      });
    }
  });
}